import React, {
    useState,
    useEffect,
    useRef,
    useLayoutEffect,
} from 'react';
import {
    MapContainer,
    TileLayer,
    Marker,
    Popup,
} from 'react-leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import L from 'leaflet';
import { toast } from 'react-toastify';
import { useParams, useHistory } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import classNames from 'classnames';
import RECAPTCHA from 'react-google-recaptcha';
import Collapse from '../shared/Collapse';
import { getData, postData } from '../../services/fetch-service';
import PageHeader from '../shared/PageHeader';
import getMenuLocation from './page/getMenuLocation';

function contact(props) {
    const url = window.location.pathname.split('/').pop();
    const history = useHistory();
    const params = useParams();
    const { locale } = props;
    const captchaRef = useRef(null);
    const [contactData, setContactData] = useState([]);
    const [cordinates, setCordinates] = useState([]);
    const [breadcrumbs, setBreadcrumbs] = useState([]);
    const [ddlcontact, setDdlContact] = useState([]);
    const [layoutId, setLayoutId] = useState();
    const [error, setError] = useState(null);
    const [errorMessage, seterrorMessage] = useState('');
    const [unmountMap, setunmountMap] = useState(false);
    const position = [42.6026, 20.9030]
    const GeneralTranslations = useSelector((state) => state.translations.GeneralTranslations);
    const ControlsTranslations = useSelector((state) => state.translations.ControlsTranslations);

    const blueIcon = L.icon({
        iconUrl: icon,
        shadowUrl: iconShadow,
        iconAnchor: [22, 45],
        popupAnchor: [-9, -48],
    });

    const [contact, setContact] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
        contactId: 0,
    });

    useEffect(() => {
        setContact({
            name: '',
            email: '',
            subject: '',
            message: '',
            contactId: 0,
        });
        getData(`Home/GetMenuPath?PageID=${params.id}&Gjuha=${locale}`).then((response) => {
            setBreadcrumbs(response.data);
            setLayoutId(response.data[0].layoutID);
        });
        getData(`Contact/GetContacts?PageID=${params.id}&Gjuha=${locale}`).then((response) => {
            setContactData(response.data);
            setCordinates(response.data);
        }).catch(() => {
            history.push('/404');
        })
        getData(`Contact/GetContactsList?PageID=${params.id}&Gjuha=${locale}`).then((response) => {
            setDdlContact(response.data);
        });
    }, [url, locale]);

    const clearFields = () => {
        setContact({
            name: '',
            email: '',
            subject: '',
            message: '',
            contactId: 0,
        });
    }

    function isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
    }

    let depatmentSelect;
    if (locale === 'sq') {
        depatmentSelect = (
            <option value="0">Zgjedhe</option>
        )
    } else if (locale === 'en') {
        depatmentSelect = (
            <option value="0">Select</option>
        )
    } else if (locale === 'sr') {
        depatmentSelect = (
            <option value="0">Izaberite</option>
        )
    }

    const sendData = () => {
        const token = captchaRef.current.getValue();
        let error = false;
        seterrorMessage('Të gjitha fushat janë obligative');
        if (token === null || token.trim().length === 0) {
            error = true;
        } else if (contact.name.trim().length === 0) {
            error = true;
        } else if (contact.subject.trim().length === 0) {
            error = true;
        } else if (contact.message.trim().length === 0) {
            error = true;
        } else if (contact.contactId === 0 || contact.contactId === '0') {
            error = true;
        } else if (!isValidEmail(contact.email)) {
            error = true;
            seterrorMessage('Formati i Email-it nuk është në rregull');
        }
        if (error === false) {
            postData(`Contact/SendMail?token=${token}&Gjuha=${locale}`, contact)
                .then((response) => {
                    if (response.data === false) {
                        toast.error('Gabim gjatë dergimit te mesazhit', { theme: 'colored' });
                        captchaRef.current.reset();
                    } else {
                        toast.success('Mesazhi u dërgua me sukses', { theme: 'colored' });
                        clearFields();
                        captchaRef.current.reset();
                    }
                });
            setError(null);
        } else {
            setError(true);
        }
    }

    useLayoutEffect(() => {
        setunmountMap(false);
        return () => {
            setunmountMap(true);
        };
    }, []);

    const handleChange = (e) => {
        e.preventDefault();
        setContact({
            ...contact,
            [e.target.name]: e.target.value,
        });
    }
    const template = getMenuLocation(layoutId);

    let inputClass = classNames('')

    if (error === true) {
        inputClass = classNames('form-control');
    } else {
        inputClass = classNames('form-control');
    }

    return (
        <React.Fragment>
            <div className="block contact-block">
                <div>
                    <div className="mb-0 contact-us">
                        <div className="contact-us__map">
                            {unmountMap === false ? (
                                <MapContainer
                                    key={cordinates}
                                    center={position}
                                    zoom={8}
                                    scrollWheelZoom={false}
                                    style={{ width: '100%', height: '400px', zIndex: 1 }}
                                >
                                    <TileLayer
                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    {cordinates.map((data, index) => (
                                        (data.latitude != null && data.longitude != null) && (
                                            <Marker
                                                position={[data.latitude, data.longitude]}
                                                icon={blueIcon}
                                                key={index}
                                            >
                                                <Popup>
                                                    {data.kontaktiPershkrimi !== '' ? (
                                                        <React.Fragment>
                                                            <b>{GeneralTranslations.contactPopupDesc}</b>
                                                            {data.kontaktiPershkrimi}
                                                        </React.Fragment>
                                                    ) : null}
                                                    {data.adresa !== '' ? (
                                                        <React.Fragment>
                                                            <br />
                                                            <b>{GeneralTranslations.contactPopupAddress}</b>
                                                            {data.adresa}
                                                        </React.Fragment>
                                                    ) : null}
                                                    {data.emaili !== '' ? (
                                                        <React.Fragment>
                                                            <br />
                                                            <b>{GeneralTranslations.contactPopupEmail}</b>
                                                            {data.emaili}
                                                        </React.Fragment>
                                                    ) : null}
                                                    {data.telefoni !== '' ? (
                                                        <React.Fragment>
                                                            <br />
                                                            <b>{GeneralTranslations.contactPopupPhone}</b>
                                                            {data.telefoni}
                                                        </React.Fragment>
                                                    ) : null}
                                                </Popup>
                                            </Marker>
                                        )
                                    ))}
                                </MapContainer>
                            ) : 'Loading Map'}
                        </div>
                        <div className="contact-header">
                            <PageHeader breadcrumb={breadcrumbs} layout={template} pika={cordinates.gps} />
                        </div>
                        <div className="contact-body">
                            <div className="contact-us__container">
                                <div className="contact-box-grid">
                                    {contactData.map((item, index) => {
                                        const renderCategory = (
                                            {
                                                toggle, setItemRef, setContentRef,
                                            },
                                        ) => {
                                            let expander;

                                            if (contactData.length > 4) {
                                                expander = <button name="selector" className="widget-categories__expander" type="button" aria-label="Expand" onClick={toggle} />
                                            }

                                            let classContactTitle = classNames('');
                                            let classContactBox = classNames('');
                                            let classContactAddress = classNames('');

                                            if (contactData.length > 4) {
                                                classContactTitle = classNames('title-collapse');
                                                classContactBox = classNames('contact-box-collapse');
                                                classContactAddress = classNames('contact-us__address_collapse');
                                            } else {
                                                classContactTitle = classNames('title-contact');
                                                classContactBox = classNames('contact-box');
                                                classContactAddress = classNames('contact-us__address');
                                            }

                                            return (
                                                <div key={index} className="" ref={setItemRef}>
                                                    <div className={classContactBox}>
                                                        <div className={classContactTitle}>
                                                            <h4 className="contact-us__header card-title">{item.kontaktiPershkrimi}</h4>
                                                            {expander}
                                                        </div>
                                                        <div className={classContactAddress} ref={setContentRef}>
                                                            {item.adresa === '' ? ('') : (
                                                                <div className="contact-text">
                                                                    <i className="contacts__icon fas fa-home" />
                                                                    <p>
                                                                        {item.adresa}
                                                                    </p>
                                                                </div>
                                                            )}
                                                            {item.personiKontaktues === '' ? ('') : (
                                                                <div className="contact-text">
                                                                    <i className="contacts__icon far fa-user" />
                                                                    <p>{item.personiKontaktues}</p>
                                                                </div>
                                                            )}
                                                            {item.emaili === '' ? ('') : (
                                                                <div className="contact-text">
                                                                    <i className="contacts__icon far fa-envelope" />
                                                                    <p>{item.emaili}</p>
                                                                </div>
                                                            )}
                                                            {item.telefoni === '' ? ('') : (
                                                                <div className="contact-text">
                                                                    <i className="contacts__icon fas fa-mobile-alt" />
                                                                    <p>{item.telefoni}</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        };
                                        return <Collapse key={index} toggleClass="menu__item--open" render={renderCategory} />;
                                    })}

                                    <div className="contact-input-grid">
                                        <div className="">
                                            <div className="contact-box input-c-box">
                                                <h4 className="contact-us__header card-title">{GeneralTranslations.contactFormName}</h4>
                                                <form>
                                                    <div className="form-row">
                                                        <div className="form-group col-md-12">
                                                            <select className={inputClass} name="contactId" onChange={handleChange}>
                                                                {depatmentSelect}
                                                                {ddlcontact.map((dep, index) => <option key={index} value={dep.kontaktiId}>{dep.kontaktiPershkrimi}</option>)}
                                                            </select>
                                                        </div>
                                                        <div className="form-group col-md-6">
                                                            <label htmlFor="name">
                                                                {GeneralTranslations.contactFormEmri}
                                                            </label>
                                                            <input type="text" id="name" name="name" value={contact.name} required onChange={handleChange} className={inputClass} />
                                                        </div>
                                                        <div className="form-group col-md-6">
                                                            <label htmlFor="email">
                                                                {GeneralTranslations.contactFormEmail}
                                                            </label>
                                                            <input
                                                                type="email"
                                                                id="email"
                                                                name="email"
                                                                className={inputClass}
                                                                value={contact.email}
                                                                required
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="subject">
                                                            {GeneralTranslations.contactFormSubject}
                                                        </label>
                                                        <input type="text" id="subject" name="subject" value={contact.subject} required onChange={handleChange} className={inputClass} />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="message">
                                                            {GeneralTranslations.contactFormMessage}
                                                        </label>
                                                        <textarea id="message" name="message" value={contact.message} required onChange={handleChange} className={inputClass} rows="4" />
                                                    </div>
                                                    <div className="captcha-box">
                                                        {error && <h5 style={{ color: 'red' }}>{errorMessage}</h5>}
                                                        <RECAPTCHA
                                                            className="form-group captcha"
                                                            sitekey={process.env.REACT_APP_SITE_KEY}
                                                            ref={captchaRef}
                                                        />
                                                    </div>
                                                    <button aria-label="button" name="submit button" type="button" onClick={sendData} className="btn btn-primary">
                                                        {ControlsTranslations.contactSendButton}
                                                    </button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
const mapStateToProps = (state) => ({
    locale: state.locale,
    translations: state.translations,
});

export default connect(mapStateToProps)(contact);
